module.exports = "mutation RevertBulkOrder($id: ID!) {\n  revertBulkOrder(id: $id) {\n    order {\n      ...DetailedOrderFragment\n    }\n  }\n}\n"